import React from 'react';
import {Typography} from "@mui/material";

const HelpPayments = () => {
    return (
        <div>
            <Typography
                variant="h6"
                component="h1"
                sx={{
                    marginBottom: '1em',
                    color:'#333333'
                }}

            >Help Payments</Typography>
            {/* Your component code goes here */}
        </div>
    );
};

export default HelpPayments;
